import React from 'react'
import styles from '../../styles/company.module.css';
import SectionTitle from '../common/SectionTitle';
import { KR } from '../../constants/localizations';

export default function CompanyHistorySection() {
    return (
        <div className={styles.history}>
            <SectionTitle title={KR.label_company_history} titleEng={KR.label_company_history_eng} />
            <div className={styles.content}>
                <div className={styles.left}>
                    <span className={styles.year}>{KR.label_company_year_2024}</span>
                    <ul>
                        <li>
                            국내 최초 완전 무인 자율주행 실외 이동로봇 운행안전인증서 취득
                        </li>
                        <li>
                            한국로봇산업진흥원 규제혁신 로봇 실증사업 순찰 로봇 서비스 선정
                        </li>
                        <li>
                            한국국토정보원 주소기반 로봇 실증 서비스 선정
                        </li>
                        <li>
                            한국국토정보원 로봇-드론 연계형 도서지역 실증 서비스 선정
                        </li>
                        <li>
                            성남시 가천대학교 캠퍼스 배송 로봇 서비스 사업 도입
                        </li>
                        <li>
                            실외/실내 공장 물류 AMR 서비스 개발 (1톤 적재 로봇)
                        </li>
                        <li>
                            로봇-엘리베이터 연동 솔루션 구축
                        </li>
                        <li>
                            Door to Door 아파트 단지 배송 전용 로봇 개발 (초소형 배달 로봇)
                        </li>
                    </ul>
                </div>
                <div className={styles.right}>
                    <div>
                        <span className={styles.year}>{KR.label_company_year_2023}</span>
                        <span className={styles.list}>
                            현대 아울렛 고객 대상 자율주행 배송 로봇 서비스 도입
                        </span>
                    </div>
                    <div>
                        <span className={styles.year}>{KR.label_company_year_2022}</span>
                        <span className={styles.list}>
                            실외 자율주행 이동로봇 솔루션 개발 및 프로토타입 운영
                        </span>
                    </div>
                    <div>
                        <span className={styles.year}>{KR.label_company_year_2021}</span>
                        <span className={styles.list}>
                            국토교통부 자율주행 자동차 임시운행 허가서 취득
                        </span>
                    </div>
                    <div >
                        <span className={styles.year}>{KR.label_company_year_2020}</span>
                        <span className={styles.list}>
                            자율주행 기업 부설 연구소 등록
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}
